import __request__ from "routing/request";
export function status(requestOptions) {
  return __request__("GET", "/system/lbstatus", null, {}, {
    "Accept": ["text/plain"]
  }, requestOptions);
}
export function override(status2, requestOptions) {
  return __request__("PUT", `/system/lbstatus/override/${status2}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
